import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ChartLineUp } from "@phosphor-icons/react";

export function ScoreModal({ scoreModal, onClose }) {
  return (
    <Dialog open={!!scoreModal} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md bg-[var(--bg-card)] border-[var(--border)]">
        <DialogHeader>
          <DialogTitle className="font-['Cormorant_Garamond'] text-xl text-[var(--text-primary)] flex items-center gap-2">
            <ChartLineUp size={20} className="text-[#FF4400]" weight="fill" />
            Content Score
          </DialogTitle>
        </DialogHeader>
        {scoreModal && (
          <div className="space-y-4 py-2" data-testid="score-modal-content">
            <div className="text-center">
              <div className={`inline-flex items-center justify-center w-20 h-20 rounded-2xl text-3xl font-bold font-['JetBrains_Mono'] ${
                scoreModal.quality_score >= 8 ? "bg-emerald-500/10 text-emerald-400 border border-emerald-500/20" :
                scoreModal.quality_score >= 6 ? "bg-blue-500/10 text-blue-400 border border-blue-500/20" :
                scoreModal.quality_score >= 4 ? "bg-amber-500/10 text-amber-400 border border-amber-500/20" :
                "bg-red-500/10 text-red-400 border border-red-500/20"
              }`} data-testid="score-modal-overall">
                {scoreModal.quality_score}
              </div>
              <p className="text-xs text-[var(--text-muted)] mt-1">out of 10</p>
            </div>

            {scoreModal.score_breakdown && (
              <div className="space-y-2" data-testid="score-breakdown">
                {Object.entries(scoreModal.score_breakdown).map(([key, val]) => {
                  const barColor = val >= 8 ? "#22C55E" : val >= 6 ? "#3B82F6" : val >= 4 ? "#F59E0B" : "#EF4444";
                  return (
                    <div key={key}>
                      <div className="flex justify-between items-center mb-0.5">
                        <span className="text-xs text-[var(--text-secondary)] capitalize">{key.replace(/_/g, " ")}</span>
                        <span className="text-xs font-['JetBrains_Mono'] text-[var(--text-muted)]">{val}/10</span>
                      </div>
                      <div className="h-1.5 rounded-full bg-[var(--bg-base)] overflow-hidden">
                        <div className="h-full rounded-full transition-all" style={{ width: `${val * 10}%`, backgroundColor: barColor }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {scoreModal.score_feedback && (
              <div className="bg-[var(--bg-base)] border border-[var(--border)] rounded-lg p-3" data-testid="score-feedback">
                <p className="text-xs font-semibold text-[var(--text-muted)] uppercase tracking-wider mb-1">AI Feedback</p>
                <p className="text-sm text-[var(--text-secondary)] leading-relaxed">{scoreModal.score_feedback}</p>
              </div>
            )}

            {scoreModal.scored_at && (
              <p className="text-[10px] text-[var(--text-muted)] text-center">
                Scored {new Date(scoreModal.scored_at).toLocaleString()}
                {scoreModal.cached && " (cached)"}
              </p>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
